import { render, staticRenderFns } from "./MaterialMaintenanceRecord.vue?vue&type=template&id=30ffa959&scoped=true"
import script from "./MaterialMaintenanceRecord.vue?vue&type=script&lang=js"
export * from "./MaterialMaintenanceRecord.vue?vue&type=script&lang=js"
import style0 from "./MaterialMaintenanceRecord.vue?vue&type=style&index=0&id=30ffa959&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ffa959",
  null
  
)

export default component.exports